module.exports = __webpack_public_path__ + "img/acores-icon.88898bba.png";